import React from "react";
import { Factory, Check } from "lucide-react";
import { EXPERTISE } from "../mock/mock";
import useInView from "../hooks/useInView";

export default function Expertise({ onJobs }) {
  const [ref, inView] = useInView();

  return (
    <section id="expertise" className="relative bg-[#0a1626] py-24">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-start transition-all duration-700 ${
          inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        {/* Left: text */}
        <div>
          <span className="text-xs font-bold tracking-[0.2em] text-[#F5941E]">
            {EXPERTISE.kicker}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            {EXPERTISE.title}
          </h2>
          <div className="mt-6 space-y-4">
            {EXPERTISE.paragraphs.map((p, i) => (
              <p
                key={i}
                className={`leading-relaxed ${
                  p.includes("né !")
                    ? "text-lg font-semibold text-[#F5941E]"
                    : "text-slate-300"
                }`}
              >
                {p}
              </p>
            ))}
          </div>
        </div>

        {/* Right: metiers card */}
        <div className="rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.05] to-transparent p-8">
          <div className="flex items-center gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F5941E]/15 text-[#F5941E]">
              <Factory size={26} />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white">
                {EXPERTISE.metiersTitle}
              </h3>
              <p className="text-sm text-slate-400">
                {EXPERTISE.metiersSubtitle}
              </p>
            </div>
          </div>

          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            {EXPERTISE.metiers.map((m) => (
              <div
                key={m}
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-slate-200 transition-all duration-300 hover:border-[#F5941E]/40 hover:bg-[#F5941E]/5 hover:translate-x-1"
              >
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#F5941E]/20 text-[#F5941E]">
                  <Check size={12} strokeWidth={3} />
                </span>
                {m}
              </div>
            ))}
          </div>

          <button
            onClick={onJobs}
            className="mt-8 w-full rounded-full bg-[#F5941E] hover:bg-[#e8850e] px-6 py-3.5 font-semibold text-white transition-all duration-300 hover:-translate-y-0.5"
          >
            Nos offres d'emploi - CDI
          </button>
        </div>
      </div>
    </section>
  );
}
